import request from './request'

export function login (data) {
  return request({
    url: '/users/sessions',
    method: 'post',
    data
  })
}

export function logout () {
  return request({
    url: '/users/sessions',
    method: 'delete'
  })
}

export function getContext () {
  return request({
    url: '/users',
    method: 'get'
  })
}

export function updateBillingInformation (data) {
  return request({
    url: '/users/billing',
    method: 'put',
    data
  })
}

export function requestResetPassword (data) {
  return request({
    url: '/users/passwords',
    method: 'post',
    data
  })
}

export function resetPassword (data) {
  return request({
    url: '/users/passwords',
    method: 'put',
    data
  })
}

export function changePassword (data) {
  return request({
    url: '/users',
    method: 'put',
    data
  })
}

export function requestAccount (data) {
  return request({
    url: '/users',
    method: 'post',
    data
  })
}
